import React from "react";



export function ItemInLegend({ item, color }) {
  return <div css={`font-size:14px;`}>
    <div css={`
    white-space:nowrap;
    display:inline-block;background-color:${color};width:12px;height:12px;margin-right:3px;vertical-align:middle;`}>
    </div>
    {item}
  </div>;
}
